import {faCheck, faEye, faFileAlt, faFileSignature, faSpinner, faStopwatch, faUserCheck} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import FasesAcontecimento from "../../../components/FasesAcontecimento";

export function fases(acontecimento) {
  return <FasesAcontecimento acontecimento={acontecimento} fases={[
    {
      field: "data_ativacao",
      descripion: ["Publicado", "Publicado"],
      icon: faEye
    },
    ...(acontecimento.curso ? [] : [
      {
        field: "data_abertura_registos",
        descripion: ["Abertura de candidaturas", "Candidaturas abertas"],
        icon: faFileSignature
      },
      {
        field: "data_limite_registos",
        descripion: ["Limite para candidaturas", "Candidaturas fechadas"],
        icon: faStopwatch
      },
      {
        field: "data_registos_fechados",
        value: acontecimento.registo ? acontecimento.registo.aprovado : null,
        descripion: ["Seleção de candidaturas", "Participantes selecionados"],
        icon: faUserCheck
      }
    ]),
    {
      field: "data_inicio",
      descripion: ["Início do módulo", "Módulo a decorrer"],
      icon: faSpinner
    },
    {
      field: "data_fim",
      descripion: ["Fim do módulo", "Fase de avaliação"],
      icon: faCheck
    },
    {
      field: "data_fecho",
      value: acontecimento.registo && acontecimento.registo.estado_participacao && acontecimento.registo.estado_participacao.code >= 100 ? acontecimento.registo.estado_participacao.at : null,
      descripion: ["Divulgação dos resultados", "Módulo terminado"],
      icon: faFileAlt
    },
  ]}/>
}